import { post } from '@utils/request';
import securityCheck from './securityCheck';

/* global ACTION_ROUTES */

export default function setJobVisibility(action) {
  const jobId = action.getAttribute('data-id');
  const visible = Boolean(action.getAttribute('data-visible'));

  const securityCheckMessage = visible ? 'Job wirklich aktivieren?' : 'Job wirklich deaktivieren?';

  if (!securityCheck(securityCheckMessage)) {
    return;
  }

  if (!isNaN(jobId)) {
    post({
      url: visible ? ACTION_ROUTES.ENABLE_JOB_VISIBILITY : ACTION_ROUTES.DISABLE_JOB_VISIBILITY,
      data: {
        jobId: jobId,
      },
      success: data => window.location.reload(),
    });
  }
}
